
import React, { useEffect, useState } from 'react';
import '../styles/Hero.css'
import { Link } from 'react-router-dom'
import cauzen from '../assest/CauZen.png'
import { useLocation } from 'react-router-dom';


const Hero = () => {
  const [index, setIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);


  return (
    <>

 <div className='mainpage-container' id='Home'>
        <div className='mainpage-wrapper'>
            <h1>Custom tech solutions—from idea to execution
for the <span> industries that shape the world.</span></h1>
        <div className='mainpage-bottom'>
       
            <div className='mainpage-left'>
                <h1>Technology with <span>purpose </span><br/> Innovation with  <span>clarity</span></h1>
                 <button
            className="main-btn"
            onClick={() => {
              document.getElementById("about").scrollIntoView({ behavior: "smooth" });
            }}
          >
            Know More <span className="arrow"><i className="fas fa-arrow-right"></i></span>
          </button>
          <button
            className="main-btn2"
            onClick={() => {
              document.getElementById("solution").scrollIntoView({ behavior: "smooth" });
            }}
          >
            View Solution <span className="arrow"><i className="fas fa-arrow-right"></i></span>
          </button>
            </div>
                    <div className='mainpage-right'>
                        <img src={cauzen}/>
                    </div>
        </div>
        </div>
        
      
    </div>





















     

      

    </>
  )
}

export default Hero
